export default "__VITE_ASSET__DsJ8OjwE__"